import { phoneRegExp } from "@autocorp/react-core/lib/regexp";
import { provinceCodes } from "@autocorp/react-core/lib/province-codes";
import { formatPhoneNumber } from "../../src/utils/format";
import { availableVerifyOpts } from "../../src/data/app";
const yup = require("yup");

export const version = "1.0.0";
export const rc = "";
export const fixedHeight = false;
export const transformers = {
    typesOfDebt: (val) => Array.isArray(val) ? val.join(",") : val,
    phoneNumber: (val) => formatPhoneNumber(val),
};
export const steps = {

    unsecured_debt: {
        chat: {
            preInput: {
                messages: [
                    "What is your total amount of debt?",
                    "This would be all your debt, not including car loans or mortgages",
                ],
            },
            postInput: {
                unsecuredDebt: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "unsecuredDebt",
                type: "radio",
                options: [
                    {
                        label: "Less than $10,000",
                        value: "less than $10,000",
                    },
                    {
                        label: "$10,000 - $20,000",
                        value: "$10,000 - $20,000",
                    },
                    {
                        label: "$20,000 - $50,000",
                        value: "$20,000 - $50,000",
                    },
                    {
                        label: "$50,000+",
                        value: "$50,000+",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: "first_name",
        expectedTime: 5, // seconds
    },

    first_name: {
        chat: {
            preInput: {
                messages: [
                    "What's your first name?",
                    "Please enter your first name as it appears on your driver's license",
                ],
            },
            postInput: {},
        },
        inputs: [
            {
                key: "firstName",
                label: "First Name",
                type: "string",
                validations: yup.string()
                    .required("First Name is required")
                    .min(2, "First Name is too short")
                    .max(20, "First Name is too long"),
                cy: {
                    correct: "First Name",
                },
            },
        ],
        nextStep: "programs",
        expectedTime: 10, //seconds
    },

    programs: {
        chat: (context) => ({
            preInput: {
                messages: [
                    `Thanks ${context.firstName}!`,
                    "At Debt Refresh© we believe every Canadian has the right to settle their debt for 0% interest through approved Government Programs",
                    "Before you go any further, please know that we will never ask you for money or a deposit",
                ],
            },
            postInput: {
                success: {
                    messages: [
                        "Thank you for your time!",
                    ],
                },
            },
        }),
        inputs: [],
        nextStep: "behind_on_bills",
        waitTime: 5,
        expectedTime: 2, //seconds
    },

    behind_on_bills: {
        chat: (context) => ({
            preInput: {
                messages: [
                    `${context.firstName}, are you currently behind on your payments?`,
                ],
            },
            postInput: {
                behindOnBills: {
                    hasTypingIndicator: true,
                },
            },
        }),
        inputs: [
            {
                key: "behindOnBills",
                type: "radio",
                options: [
                    {
                        label: "Yes",
                        value: "yes",
                    },
                    {
                        label: "No",
                        value: "no",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: (context) =>
            (context.behindOnBills === "yes")
                ? "debt_time"
                : "number_of_debts",
        expectedTime: 5, // seconds
    },

    debt_time: {
        chat: {
            preInput: {
                messages: [
                    "How many days are you behind on payments?",
                    "Did you know that over 30% of Canadians are behind on their bills? We can help!",
                ],
            },
            postInput: {
                debtTime: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "debtTime",
                type: "radio",
                options: [
                    {
                        label: "A few weeks",
                        value: "a few weeks",
                    },
                    {
                        label: "30 - 60 days",
                        value: "30 - 60 days",
                    },
                    {
                        label: "60 - 90 days",
                        value: "60 - 90 days",
                    },
                    {
                        label: "Over 3 Months",
                        value: "over 3 months",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: "number_of_debts",
        expectedTime: 5, // seconds
    },

    number_of_debts: {
        chat: {
            preInput: {
                messages: [
                    "How many creditors do you owe money to?",
                    "A creditor is any company you have outstanding balances with and that needs to be paid",
                ],
            },
            postInput: {
                numberOfDebts: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "numberOfDebts",
                type: "radio",
                options: [
                    {
                        label: "1",
                        value: "1",
                    },
                    {
                        label: "2",
                        value: "2",
                    },
                    {
                        label: "3 - 5",
                        value: "3 - 5",
                    },
                    {
                        label: "6 - 9",
                        value: "6 - 9",
                    },
                    {
                        label: "10+",
                        value: "10+",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: "types_of_debt",
        expectedTime: 5, // seconds
    },

    types_of_debt: {
        chat: (context) => ({
            preInput: {
                messages: [
                    `What types of debt do you have ${context.firstName}?`,
                    "Please select all that are applicable",
                ],
            },
            postInput: {
                typesOfDebt: {
                    hasTypingIndicator: true,
                },
            },
        }),
        inputs: [
            {
                key: "typesOfDebt",
                type: "select",
                label: "Types of Debt",
                multiple: true,
                options: [
                    {
                        label: "Credit Cards",
                        value: "credit cards",
                    },
                    {
                        label: "Payday Loans",
                        value: "payday loans",
                    },
                    {
                        label: "Personal Loan",
                        value: "personal loan",
                    },
                    {
                        label: "Store Cards",
                        value: "store cards",
                    },
                    {
                        label: "CRA Debt",
                        value: "cra debt",
                    },
                    {
                        label: "Student Loans",
                        value: "student loans",
                    },
                    {
                        label: "Line of Credit",
                        value: "line of credit",
                    },
                    {
                        label: "Other",
                        value: "other",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: (context) =>
            (context.typesOfDebt.includes("student loans"))
                ? "student_loan_debt"
                : "credit_rating",
        expectedTime: 5, // seconds
    },

    student_loan_debt: {
        chat: {
            preInput: {
                messages: [
                    `How much student loan debt do you have? 🧐`,
                ],
            },
            postInput: {
                studentLoanDebt: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "studentLoanDebt",
                label: "Student Loan Debt ($)",
                type: "number",
                validations: yup.number()
                    .typeError("Student Loan Debt must be a number")
                    .required("Student Loan Debt is required")
                    .min(0, "Invalid Input"),
                cy: {
                    correct: 4000,
                },
            },
        ],
        nextStep: "credit_rating",
        expectedTime: 10, // seconds
    },

    credit_rating: {
        chat: {
            preInput: {
                messages: [
                    "How would you rate your credit?",
                ],
            },
            postInput: {
                creditRating: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "creditRating",
                type: "radio",
                options: [
                    {
                        label: "Excellent 👌",
                        value: "excellent",
                    },
                    {
                        label: "Good 👍",
                        value: "good",
                    },
                    {
                        label: "Fair 🤙",
                        value: "fair",
                    },
                    {
                        label: "Poor 😐",
                        value: "poor",
                    },
                    {
                        label: "Very poor 😬",
                        value: "very poor",
                    },
                    {
                        label: "Not sure 🤔",
                        value: "not sure",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: "employment_status",
        expectedTime: 5, // seconds
    },

    employment_status: {
        chat: {
            preInput: {
                messages: [
                    "What is your employment status?",
                    "This will help to qualify for your application",
                ],
            },
            postInput: {
                employmentStatus: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "employmentStatus",
                type: "radio",
                options: [
                    {
                        label: "Employed",
                        value: "employed",
                    },
                    {
                        label: "Pension",
                        value: "pension",
                    },
                    {
                        label: "Disability",
                        value: "disability",
                    },
                    {
                        label: "Self Employed",
                        value: "self employed",
                    },
                    {
                        label: "Unemployed",
                        value: "unemployed",
                    },
                    {
                        label: "Other",
                        value: "other",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: "residency_status",
        expectedTime: 5, // seconds
    },

    residency_status: {
        chat: {
            preInput: {
                messages: [
                    "Do you rent or own your current place?",
                ],
            },
            postInput: {
                residencyStatus: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "residencyStatus",
                type: "radio",
                options: [
                    {
                        label: "Rent",
                        value: "rent",
                    },
                    {
                        label: "Own",
                        value: "own",
                    },
                ],
                validations: yup.string().required("Please select an option"),
            },
        ],
        waitTime: null,
        nextStep: (context) =>
            (context.residencyStatus === "own")
                ? "property_value"
                : "monthly_payment",
        expectedTime: 10, //seconds
    },

    property_value: {
        chat: {
            preInput: {
                messages: [
                    `What is your estimated property value?`,
                    "Don't worry! We're just asking for your best guess on the current market value of your property",
                ],
            },
            postInput: {
                propertyValue: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "propertyValue",
                label: "Property Value ($)",
                type: "number",
                validations: yup.number()
                    .typeError("Property Value must be a number")
                    .required("Property Value is required")
                    .min(0, "Invalid Input"),
            },
        ],
        nextStep: "mortgage_balance",
        expectedTime: 10, // seconds
    },

    mortgage_balance: {
        chat: {
            preInput: {
                messages: [
                    `What is the balance of your mortgage?`,
                ],
            },
            postInput: {
                mortgageBalance: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "mortgageBalance",
                label: "Mortgage Balance ($)",
                type: "number",
                validations: yup.number()
                    .typeError("Mortgage Value must be a number")
                    .required("Mortgage Value is required")
                    .min(0, "Invalid Input"),
                cy: {
                    correct: 4000,
                },
            },
        ],
        nextStep: "home_ownership_percentage",
        expectedTime: 10, // seconds
    },

    home_ownership_percentage: {
        chat: (context) => ({
            preInput: {
                messages: [
                    `What percentage of the home do you own, ${context.firstName}?`,
                    "For example, if you have a joint mortgage with a partner, you would own 50%",
                ],
            },
            postInput: {
                homeOwnershipPercentage: {
                    hasTypingIndicator: true,
                },
            },
        }),
        inputs: [
            {
                key: "homeOwnershipPercentage",
                label: "Home Ownership Percentage (%)",
                type: "number",
                validations: yup.number()
                    .typeError("Home Ownership Percentage must be a number")
                    .required("Home Ownership Percentage is required")
                    .min(0, "Invalid Input"),
            },
        ],
        nextStep: "monthly_payment",
        expectedTime: 10, // seconds
    },

    monthly_payment: {
        chat: {
            preInput: {
                messages: [
                    `What is your monthly house payment?`,
                    "This includes what portion of your rent or mortgage payment that you are responsible for",
                ],
            },
            postInput: {
                monthlyPayment: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "monthlyPayment",
                label: "Monthly Payment ($)",
                type: "number",
                validations: yup.number()
                    .typeError("Monthly Payment must be a number")
                    .required("Monthly Payment is required")
                    .min(0, "Invalid Input"),
            },
        ],
        nextStep: "address",
        expectedTime: 10, // seconds
    },

    address: {
        chat: {
            preInput: {
                messages: [
                    "We need a little information about where you live",
                    "This will help us match you to the best debt solutions possible!",
                ],
            },
            postInput: {},
        },
        inputs: [
            {
                key: "postalCode",
                label: "Postal Code",
                type: "string",
                validations: yup.string()
                    .required(`Postal Code is required`),
                cy: {
                    correct: "K1Y 2S3",
                },
            },
            {
                key: "city",
                label: "City",
                type: "string",
                validations: yup.string().required("City is required"),
                cy: {
                    correct: "Toronto",
                },
            },
            {
                key: "provinceCode",
                label: "Province",
                type: "select",
                options: provinceCodes,
                validations: yup.string().required(`Province is required`),
                cy: {
                    ignoreBranch: true,
                    correct: "ON",
                },
            },
        ],
        nextStep: "email_address",
        expectedTime: 15,
    },

    // search_partners: {
    //     chat: (context) => ({
    //         preInput: {
    //             messages: [
    //                 `Almost done! Give me a moment while I check for lenders near ${context.postalCode}.`,
    //             ],
    //         },
    //         postInput: {
    //             searchPartners: {
    //                 hasTypingIndicator: true,
    //                 messages: [
    //                     "Looks like we found a few matches!",
    //                 ],
    //             },
    //         },
    //     }),
    //     inputs: [
    //         {
    //             key: "searchPartners",
    //             type: "presentational-searching",
    //             searchingForList: [
    //                 "Looking for Debt Partners...",
    //                 "Searching for Programs...",
    //             ],
    //         },
    //     ],
    //     waitTime: 2,
    //     nextStep: "email_address",
    //     expectedTime: 5, //seconds
    // },

    email_address: {
        chat: {
            preInput: {
                messages: [
                    "What's your email?",
                    "We only use this to provide you the information you’re requesting. No spam!",
                ],
            },
            postInput: {
                email: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "email",
                label: "Email Address",
                type: "string",
                validations: yup.string()
                    .required("Email Address is required")
                    .email("Must be valid email format"),
                cy: {
                    correct: "test@email.com",
                    wrong: "wrongemail.com",
                },
            },
        ],
        nextStep: "last_name",
        expectedTime: 10, // seconds
    },

    last_name: {
        chat: (context) => ({
            preInput: {
                messages: [
                    `${context.firstName} what's your last name?`,
                ],
            },
            postInput: {
                lastName: {
                    hasTypingIndicator: true,
                },
            },
        }),
        inputs: [
            {
                key: "lastName",
                label: "Last Name",
                type: "string",
                validations: yup.string()
                    .required("Last Name is required")
                    .min(2, "Last Name is too short")
                    .max(20, "Last Name is too long"),
            },
        ],
        nextStep: "comments",
        expectedTime: 10, //seconds
    },

    comments: {
        chat: (context) => ({
            preInput: {
                messages: [
                    "We're almost done!",
                    `${context.firstName}, can you please briefly describe your debt problem and what you are going through?`,
                ],
            },
            postInput: {
                comments: {
                    hasTypingIndicator: true,
                },
            },
        }),
        inputs: [
            {
                key: "comments",
                label: "Comments",
                type: "textarea",
                validations: yup.string(),
            },
        ],
        nextStep: "phoneNumber",
        expectedTime: 10, //seconds
    },

    phoneNumber: {
        chat: {
            preInput: {
                messages: [
                    "What's the best phone number to reach you?",
                    "We need your contact information to be able to reach out and confirm the details of your application. We won't spam you or share your contact information with anyone.",
                ],
            },
            postInput: {
                phoneNumber: {
                    hasTypingIndicator: true,
                },
            },
        },
        inputs: [
            {
                key: "phoneNumber",
                label: "Phone",
                type: "tel",
                validations: yup.string()
                    .required("Phone Number is required")
                    .matches(phoneRegExp, "Phone number is not valid"),
                cy: {
                    correct: 5555555555,
                },
            },
        ],
        nextStep: (context, configValue) => {
            const verifyMethods = configValue("twilioVerifyMethods");
            return verifyMethods.length === 1
                ? "verify_code"
                : "verify_options";
        },
        expectedTime: 10, //seconds
    },

    verify_options: {
        chat: (context, configValue) => {
            const isVerifyRequired = configValue("twilioVerifyRequired");
            const skipMessage = isVerifyRequired
                ? ""
                : "You have the option to skip this step.";
            return {
                preInput: {
                    messages: [
                        "We would like to verify your identity.",
                        `Please select one of the verification methods below. ${skipMessage}`,
                    ],
                },
                postInput: {
                    verifyOptions: {
                        hasTypingIndicator: true,
                    },
                },
            };
        },
        inputs: (context, configValue) => {
            const isVerifyRequired = configValue("twilioVerifyRequired");
            const verifyMethods = configValue("twilioVerifyMethods");
            const verifyOptions = verifyMethods.map((method) => {
                return availableVerifyOpts[method];
            });
            if (!isVerifyRequired) {
                verifyOptions.push(availableVerifyOpts["skip"]);
            }
            return [
                {
                    key: "verifyOptions",
                    type: "radio",
                    options: verifyOptions,
                    validations: yup.string()
                        .required("Please select an option"),
                    cy: {
                        critical: [0],
                    },
                },
            ];
        },
        waitTime: null,
        nextStep: (context) => (
            (context.verifyOptions === "skip") ? "submit" : "verify_code"
        ),
        expectedTime: 5, //seconds
    },

    verify_code: {
        chat: (context, configValue) => {
            let message = "";
            const verifyMethods = configValue("twilioVerifyMethods");
            if (verifyMethods.length === 1) {
                switch (verifyMethods[0]) {
                    case "sms":
                        message = `Enter the verification code sent to ${context.phoneNumber} via SMS.`;
                        break;
                    case "email":
                        message = `Enter the verification code sent to your email: ${context.email}.`;
                        break;
                    case "call":
                        message = `Enter the verification code you received on the phone at ${context.phoneNumber}.`;
                        break;
                }
            } else {
                message = (context.verifyOptions === "email")
                    ? `We've sent a verification code to your email: ${context.email}.`
                    : (context.verifyOptions === "sms")
                        ? `We've sent you a verification code via SMS to ${context.phoneNumber}.`
                        : `We've provided you a verification code via a phone call to ${context.phoneNumber}.`;
            }
            return ({
                preInput: {
                    messages: [
                        `Perfect! ${message} Please enter the code below.`,
                    ],
                },
                postInput: {
                    verifyCode: {
                        messages: [
                            "Great! It looks like you have been verified. 🤗",
                        ],
                        hasTypingIndicator: true,
                    },
                },
            });
        },
        inputs: [
            {
                key: "verifyCode",
                type: "verify-code",
            },
        ],
        waitTime: 2,
        nextStep: "submit",
        expectedTime: 5, //seconds
    },

    submit: {
        chat: (context) => ({
            preInput: {
                messages: [
                    `Congratulations ${context.firstName}! You qualify for Debt Refresh!`,
                    "Please read and agree to our terms and services.",
                ],
            },
            postInput: {
                authorized: {
                    hasTypingIndicator: true,
                },
            },
        }),
        inputs: (_, configValue) => [
            {
                key: "authorized",
                type: "submit-blurb",
                buttonText: "I Agree",
                body1: `By clicking on the I AGREE Button, I consent to be contacted via email, phone & text by Debt Refresh© and its partners, who are approved debt advisors and licensed insolvency trustees. Regarding but not limited to debt relief programs, finance-related products, services and promotions.`,
                body2: "You can withdraw your consent at any time.",
            },
        ],
        hideSubmit: true,
        waitTime: 0,
        nextStep: "success",
        expectedTime: 10,
    },

    success: {
        chat: {
            preInput: {
                messages: [
                    `Perfect, we're all done!`,
                ],
            },
            postInput: {
                success: {
                    messages: [
                        "Thank you for your time!",
                    ],
                },
            },
        },
        inputs: [
            {
                key: "success",
                type: "presentational-success",
                title: "Success",
                body: "Your application has been submitted successfully. One of our debt partners will be in contact with you shortly.",
            },
            {
                type: "presentational-success-ctas",
                compact: true,
            },
        ],
        nextStep: null,
    },
};